import { z } from 'zod';
import { stringValidator } from '@lucidlink/dto/validation';
export const VerifyUserEmail = z.object({
    code: stringValidator({
        requiredError: 'emailVerification.code.required',
    }),
});
